// extracted by mini-css-extract-plugin
export var form = "RushForm-module--form--c8215";
export var iconSpinner = "RushForm-module--iconSpinner--48a93";
export var spin = "RushForm-module--spin--cea89";
export var spinner = "RushForm-module--spinner--c5652";